const SIZES = ["mini", "small", "medium", "large"];
const BORDER_SHAPES = ["square", "round", "circle"];
const STATUSES = ["normal", "success", "warning", "danger"];
const MESSAGE_TYPES = ["info", "success", "warning", "error"];
const TRIGGER_POSITIONS = [
  "top",
  "tl",
  "tr",
  "bottom",
  "bl",
  "br",
  "left",
  "lt",
  "lb",
  "right",
  "rt",
  "rb"
];
const TRIGGER_EVENTS = [
  "hover",
  "click",
  "focus",
  "contextMenu"
];
const DIRECTIONS = ["horizontal", "vertical"];
const INPUT_EVENTS = [
  "onFocus",
  "onFocusin",
  "onFocusout",
  "onBlur",
  "onChange",
  "onBeforeinput",
  "onInput",
  "onReset",
  "onSubmit",
  "onInvalid",
  "onKeydown",
  "onKeypress",
  "onKeyup",
  "onCopy",
  "onCut",
  "onPaste",
  "onCompositionstart",
  "onCompositionupdate",
  "onCompositionend",
  "onSelect"
];
export { BORDER_SHAPES, DIRECTIONS, INPUT_EVENTS, MESSAGE_TYPES, SIZES, STATUSES, TRIGGER_EVENTS, TRIGGER_POSITIONS };
